/** PLG is US-only (and the portal accepts only 10-digit US numbers), so the phone field offers the US alone. */
export const US_ONLY = ["US"];

/** Prototype phone placeholder "614 555 0142": digits grouped 3-3-4 as they are typed. */
export function formatUsPhone(digits: string): string {
  const d = digits.replace(/\D/g, "");
  return [d.slice(0, 3), d.slice(3, 6), d.slice(6)].filter(Boolean).join(" ");
}
